import {FC, ReactNode} from 'react';
import {useTableRowGroup} from 'react-aria';
import TableStaticHeadBody from 'components/Table/TableStatic/TableStaticHeaderBody';

type TableHeadBodyProps = {
    children: ReactNode;
};

const TableHeadBody: FC<TableHeadBodyProps> = ({children}) => {
    const {rowGroupProps} = useTableRowGroup();

    return (
        <TableStaticHeadBody {...rowGroupProps}>{children}</TableStaticHeadBody>
    );
};

export default TableHeadBody;
